import * as z from "zod";
import { ProductAnalyticsFilterSchema } from "./filters/analytics-filter";
import { ViewByEnum, ViewByToggleSchema } from "./filters/view-by-toggle";
import {
  ProductSchema,
  ProductSortSchema,
  ReturnReasonSchema,
} from "./product-analytics.types";

// Input schema for product analytics
export const ProductAnalyticsInputSchema = z.object({
  sort: ProductSortSchema.nullish(),
  filters: z
    .array(ProductAnalyticsFilterSchema)
    .nullish()
    .describe(
      "Filters to apply to the product analytics. When used by an agent, be sure to ask the user for clarification on what the filters should be set to.",
    ),
  viewBy: ViewByToggleSchema.default(ViewByEnum.ORDER_DATE).describe(
    "Whether to view analytics by order date or processed date",
  ),
});

// Output schema for product analytics
export const ProductAnalyticsOutputSchema = z.object({
  products: z.array(ProductSchema),
  returnReasons: z.array(ReturnReasonSchema),
});

// Export type definitions for TypeScript
export type ProductAnalyticsInput = z.infer<typeof ProductAnalyticsInputSchema>;
export type ProductAnalyticsOutput = z.infer<
  typeof ProductAnalyticsOutputSchema
>;

// Define the entire schema for RPC usage
export const getReturnAnalyticsByProduct = {
  input: ProductAnalyticsInputSchema,
  output: ProductAnalyticsOutputSchema,
};
